import DeleteConsultingCompanyContainer from "./DeleteConsultingCompanyContainer";
export default DeleteConsultingCompanyContainer;
